import React, { useState, useLayoutEffect } from 'react';
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Alert,
} from '@themesberg/react-bootstrap';
import { FaUserAlt, FaKey } from 'react-icons/fa';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';
import { getLandingPath } from '../../utils/access';
import LOGO from '../../assets/img/logo.jpg'
import { post } from '../../services/back.service';
import { setMenu, setToken, setCurrentUser, setName, setUserType, setRole, setPermission } from '../../reducers/userSlice';
import { useDispatch, useSelector } from "react-redux";

function Login() {
  const dispatch = useDispatch()
  const userType = useSelector((state) => state.user.userType)

  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [autenticate, setAutenticate] = useState(false);
  const [showAlert, setShow] = useState(false);
  const [messageAlert, setMessageShow] = useState('');

  useLayoutEffect(() => {
    if (isAuthenticated()) setAutenticate(true);
  }, []);

  const submit = async () => {
    const body = {
      user,
      pass
    }
    const response = await post('/auth/login', body)
    const validacion = response.success;

    if (validacion) {
      const { data } = response;
      dispatch(setMenu(data.menu));
      dispatch(setToken(data.token));
      dispatch(setCurrentUser(data.user));
      dispatch(setName(data.name));
      dispatch(setUserType(data.user_type));
      dispatch(setRole(data.role));
      dispatch(setPermission(data.permissions));
      localStorage.setItem('token', data.token);
      localStorage.setItem('user_id', data.user);
      setAutenticate(true);
    } else {
      setShow(true)
      setMessageShow(response.message)
    }
  };

  const validarEnter = (e) => {
    if (e.keyCode === 13) submit();
  }

  if (autenticate) return <Navigate to={getLandingPath(userType)} replace />;
  return (
    <main>
      <section className="d-flex align-items-center vh-100 bg-login">
        <Container fluid>
          <p className="text-center">
            <Card.Link className="text-gray-700">
              {/* <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage */}
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-80 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">

                  <img src={LOGO} width={250} alt="IntegraMotor - Centro integral automotor" />

                  <h3 className="mb-0 mt-4 fs-6 fw-bold">Iniciar sesión</h3>
                </div>
                {showAlert && <Alert variant="danger">{messageAlert}</Alert>}
                <Form className="mt-4">
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Usuario</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FaUserAlt />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="user"
                        onKeyUp={(e) => validarEnter(e)}
                        onChange={(e) => setUser(e.target.value)}
                        value={user}
                        placeholder="Ingrese su usuario..."
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Contraseña</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FaKey />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          onKeyUp={(e) => validarEnter(e)}
                          onChange={(e) => setPass(e.target.value)}
                          placeholder="Ingresar contraseña..."
                        />
                      </InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      {/* <Form.Check type="checkbox">
                        <FormCheck.Input id="defaultCheck5" className="me-2" />
                        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Remember me</FormCheck.Label>
                      </Form.Check> */}
                      {/* <Card.Link className="small text-end">Lost password?</Card.Link> */}
                    </div>
                  </Form.Group>
                  <Button

                    onClick={() => submit()}
                    className="w-100"
                  >
                    Ingresar
                  </Button>
                </Form>
                {/* <div className="mt-3 mb-4 text-center">
                  <span className="fw-normal">or login with</span>
                </div> */}

              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
}

export default Login;
